import { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE } from "@config/env";
import { Modal, ModalFooter } from "@common/Modal";

const post = (ep, f) => {
  const fd = new FormData();
  Object.entries(f).forEach(([k,v]) => fd.append(k,v));
  return axios.post(`${API_BASE}${ep}`, fd).then(r=>r.data).catch(()=>null);
};

const SkillsModal = ({ candidate, userSlug, onClose }) => {
  const [allSkills,  setAllSkills]  = useState(candidate.skills || []);
  const [loading,    setLoading]    = useState(true);
  const [filter,     setFilter]     = useState("");

  // Fetch full skill list on open
  useEffect(() => {
    const slug = candidate.user_slug || candidate.id;
    if (!slug) { setLoading(false); return; }
    post("get-all-raw-skills", { user_slug: userSlug, resource_slug: slug })
      .then(d => {
        const fetched = d?.skills || d?.skill_list || [];
        if (fetched.length > 0) {
          setAllSkills(fetched.map(s => s.skill_name || s).filter(Boolean));
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const totalCount = candidate.skillCount || allSkills.length;
  const displayed  = filter
    ? allSkills.filter(s => s.toLowerCase().includes(filter.toLowerCase()))
    : allSkills;

  const title = (
    <div style={{ display:"flex", alignItems:"center", gap:10 }}>
      <div style={{ width:36, height:36, borderRadius:10, background:"var(--fc-primary-light)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
        <i className="fa-solid fa-code" style={{ color:"var(--fc-primary)", fontSize:15 }} />
      </div>
      <div>
        <div style={{ fontSize:15, fontWeight:700, color:"var(--fc-text-primary)" }}>Skills & Expertise</div>
        <div style={{ fontSize:11, color:"var(--fc-text-muted)", marginTop:2 }}>
          {candidate.name} · {loading ? "Loading..." : `${totalCount} skills`}
        </div>
      </div>
    </div>
  );

  return (
    <Modal title={title} onClose={onClose} maxWidth={520}
      footer={<ModalFooter onConfirm={onClose} confirmLabel="Close" />}>

      {/* Filter */}
      <div style={{ marginBottom:14 }}>
        <input value={filter} onChange={e=>setFilter(e.target.value)} placeholder="Filter skills..."
          style={{ width:"100%", boxSizing:"border-box", padding:"8px 12px", border:"1.5px solid var(--fc-border)", borderRadius:"var(--fc-radius-md)", fontSize:13, outline:"none", fontFamily:"inherit" }}
          onFocus={e=>e.target.style.borderColor="var(--fc-primary)"} onBlur={e=>e.target.style.borderColor="var(--fc-border)"} />
      </div>

      {/* Skills */}
      {loading ? (
        <div style={{ textAlign:"center", padding:"32px 0", color:"var(--fc-text-subtle)" }}>
          <i className="fa-solid fa-spinner fa-spin" style={{ fontSize:20, marginBottom:8, display:"block" }} />
          <div style={{ fontSize:13 }}>Loading all skills...</div>
        </div>
      ) : displayed.length === 0 ? (
        <div style={{ textAlign:"center", color:"var(--fc-text-subtle)", fontSize:13, padding:"24px 0" }}>
          {filter ? `No skills match "${filter}"` : "No skills listed"}
        </div>
      ) : (
        <>
          <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
            {displayed.map((s,i) => (
              <span key={i} style={{ padding:"6px 14px", background:"var(--fc-primary-light)", border:"1px solid var(--fc-primary-border)", borderRadius:99, fontSize:12, fontWeight:600, color:"var(--fc-primary)" }}>{s}</span>
            ))}
          </div>
          {filter && (
            <div style={{ fontSize:11, color:"var(--fc-text-subtle)", marginTop:10 }}>
              Showing {displayed.length} of {allSkills.length}
            </div>
          )}
        </>
      )}
    </Modal>
  );
};

export default SkillsModal;
